import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import FreeTag from './FreeTag';
import InvitationOnlyTag from './InvitationOnlyTag';
import OnlineTag from './OnlineTag';
import Tag from './Tag';

import styles from '../../../styles/partials/card-tags.module.scss';

const propTypes = {
    withOnline: PropTypes.bool,
    withFree: PropTypes.bool,
    withQA: PropTypes.bool,
    withCaptions: PropTypes.bool,
    withInvitationOnly: PropTypes.bool,
    year: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    withOnline: false,
    withFree: false,
    withInvitationOnly: false,
    year: null,
    withQA: false,
    withCaptions: false,
    className: null,
};

const CardTags = ({
    className,
    withOnline,
    withFree,
    withInvitationOnly,
    withQA,
    withCaptions,
    year,
}) => {
    if (!withOnline && !withFree && !year && !withQA && !withCaptions && !withInvitationOnly)
        return null;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {year !== null ? <Tag label={year} color="secondary" /> : null}
            {withOnline ? <OnlineTag /> : null}
            {withFree ? <FreeTag /> : null}
            {withInvitationOnly ? <InvitationOnlyTag /> : null}
            {withQA ? (
                <Tag
                    label={
                        <FormattedMessage defaultMessage="With guests" description="tag label" />
                    }
                    color="dark"
                />
            ) : null}
            {withCaptions ? (
                <Tag
                    label={<FormattedMessage defaultMessage="CC" description="tag label" />}
                    color="highlight"
                />
            ) : null}
        </div>
    );
};
CardTags.propTypes = propTypes;
CardTags.defaultProps = defaultProps;

export default CardTags;
